var map = {
	"./heart_emoji.png": 686,
	"./heart_eyes_emoji.png": 842,
	"./party_face_emoji.png": 687,
	"./sad_emoji.png": 680,
	"./slightly_smiling_emoji.png": 843,
	"./thumbs_up_emoji.png": 844,
	"./waving_hand_emoji.png": 845
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1429;